import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "about-me-container" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("h2", null, "About Me", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[1] || (_cache[1] = _createElementVNode("strong", null, "User Id:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.userData?.id), 1)
      ]),
      _createElementVNode("p", null, [
        _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Name:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.userData?.name), 1)
      ]),
      _createElementVNode("p", null, [
        _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Role:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.role), 1)
      ]),
      _createElementVNode("p", null, [
        _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Mail:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.userData?.mail), 1)
      ]),
      _createElementVNode("p", null, [
        _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Invoice Address:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.userData?.invoiceAddress), 1)
      ]),
      _createElementVNode("p", null, [
        _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Invoice Mail:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.userData?.invoiceMail), 1)
      ]),
      _createElementVNode("p", null, [
        _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Invoice Mobile:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.userData?.invoiceMobile), 1)
      ])
    ]),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
            class: "logout-btn"
          }, "Logout"),
          _createVNode(_component_router_link, { to: "/user-edit" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("button", { class: "create-btn" }, "Edit Profile", -1)
            ])),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}